import styled from '@mui/material/styles/styled';
import { Button, ButtonProps } from '@mui/material';
import { AppButtonProps } from './AppButton';
import { useWindowDimensions } from '../../Helpers/Hooks';

const StyledButton = styled(Button)<ButtonProps & AppButtonProps>(({ wrapText }) => ({
	whiteSpace: wrapText ? 'normal' : 'nowrap',
}));

export const BaseButton = ({ fontSize, fontWeight, minWidth, ...props }: ButtonProps & AppButtonProps) => {
	const screen = useWindowDimensions();
	const isMobile: boolean = screen.isMobile;
	const defaultMinWidth = isMobile ? '32px' : '64px';

	return (
		<StyledButton
			{...props}
			style={{
				...props.style,
				minWidth: minWidth || defaultMinWidth,
				fontWeight: fontWeight,
				fontSize: fontSize,
			}}
		>
			{props.children}
		</StyledButton>
	);
};
